import { DocumentEventsService } from 'src/app/shared/services/document-events/document-events.service';
import { AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, Input } from '@angular/core';
import { UIMonitorTask } from '../monitor-step/monitor-step.component';
import { extractLinesFromTextNode } from '../../../../functions/helpers/extract-lines-from-node';
import { debounceTime } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ChangeDetectionService } from 'src/app/core/services/change-detection/change-detection.service';

@Component({
  standalone: true,
  imports: [],
  template: '',
})
export abstract class MonitorStepReasonComponent implements AfterViewInit {
  @Input({required: true}) public abstract task: UIMonitorTask;
  public isCollapsible = false;
  private cdr = inject(ChangeDetectorRef)

  private documentEventsService = inject(DocumentEventsService);
  private destroyRef = inject(DestroyRef);

  public ngAfterViewInit(): void {
    this.setIsCollapsible();
    this.documentEventsService.windowResizeEvent
    .pipe(
      takeUntilDestroyed(this.destroyRef), 
      debounceTime(300))
    .subscribe(() => this.setIsCollapsible());
    ChangeDetectionService.detectChanges(this.cdr);
  }

  protected setIsCollapsible(): void {
    const elem = document.getElementById(this.getTextElementName());
    if (elem) {
      //Always show icon if text was truncated.
      if (elem.classList.contains('truncate')) {
        this.isCollapsible = true;
      }
      else if (elem.firstChild !== null) {
        this.isCollapsible = extractLinesFromTextNode(elem.firstChild).length > 1;
      }
      ChangeDetectionService.detectChanges(this.cdr);
    }
  }

  protected abstract getTextElementName(): string;
}